import styles from './CollapsedSidebarSearch.css'

type Props = {
  searchInputId: string
}
export default function CollapsedSidebarSearch({searchInputId}: Props) {
  return (
    <div className={styles.rotatedBar}>
      <label htmlFor={searchInputId} className={styles.label}>
        {'Q – search'}
      </label>
    </div>
  )
}
